module.exports = __webpack_public_path__ + "img/china-southern.98a0eac0.jpg";